module.exports = __webpack_public_path__ + "static/img/newsbannertwo.0dc4292.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsbannertwo.png
// module id = Xj/r
// module chunks = 45